// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel {
    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.attributeTypeMap;
    }
}
SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.discriminator = undefined;
SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.additionalProperties = false;
SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel"
    },
];
//# sourceMappingURL=sharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.js.map